'use client';

// import { ApexOptions } from "apexcharts";
import dynamic from 'next/dynamic';
import {
  formatNumber,
  formatNumberKeepDecimal,
} from '@/features/tools/helper/formatter';

const ReactApexChart = dynamic(() => import('react-apexcharts'), {
  ssr: false,
});

interface ColumnData {
  xAxisName: String;
}

export function StackedColumnGraph({
  data,
  columnLabel,
  xLabel,
}: {
  data: any[];
  columnLabel: any[];
  xLabel?: string;
}) {
  // const data = columnData;

  // if (data.length == 0) {
  //   return null;
  // }

  // const investedData = [];
  // const contractBalanceData = [];
  // const cumulativeProfit = [];
  // const xAxisName = [];

  // // data.forEach((item) => {
  // //   investedData.push(item.totalInvested);
  // //   contractBalanceData.push(item.contractBalance);
  // //   xAxisName.push(item.date);
  // // });

  // data.forEach((item) => {
  //   cumulativeProfit.push(item.pnl);
  //   xAxisName.push(item.date);
  // });

  // const series = [
  //   // {
  //   //   name: "Total Invested",
  //   //   data: investedData,
  //   //   color: "#008ffb",
  //   // },

  //   {
  //     name: 'Cumulative P&L',
  //     data: cumulativeProfit,
  //     color: '#00e396',
  //   },
  // ];
  // const options = {
  //   chart: { toolbar: { show: false }, zoom: { enabled: false } },
  //   // colors: [
  //   //   function ({ value, seriesIndex, dataPointIndex, w, o }) {
  //   //     console.log("value", value, dataPointIndex);
  //   //     if (value < 0) {
  //   //       return "#e31e09";
  //   //     } else {
  //   //       return "#16A34A";
  //   //     }
  //   //   },
  //   // ],
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   stroke: {
  //     curve: 'smooth',
  //   },
  //   xaxis: {
  //     type: 'datetime',
  //     categories: xAxisName,
  //     labels: {
  //       datetimeUTC: false,
  //       format: 'MMM-dd',
  //     },
  //   },
  // };

  var series = data;

  const options = {
    chart: {
      toolbar: { show: false },
      zoom: { enabled: false },
      stacked: true,
    },
    // colors: ['#33B8FC', '#2D75C5', '#CCEDFE'],
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: columnLabel,
      labels: {
        formatter: function (val: any) {
          return xLabel ? xLabel + ' ' + val : 'Year ' + val;
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val: any) {
          return 'RM ' + formatNumber(val);
        },
        style: {
          fontSize: '14px',
        },
      },
    },
    legend: {
      showForSingleSeries: true,
      position: 'top',
      horizontalAlign: 'left',
      fontSize: '14px',
      fontWeight: 400,
      labels: {
        colors: '#00346E',
        useSeriesColors: false,
      },
      onItemClick: {
        toggleDataSeries: false,
      },
      onItemHover: {
        highlightDataSeries: false,
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box p-3 bg-[#2D75C5] text-white border-0">' +
          '<div class="text-xs">' +
          w.globals.initialSeries[seriesIndex].name +
          '</div>' +
          '<div class="font-bold text-sm">RM ' +
          formatNumberKeepDecimal(series[seriesIndex][dataPointIndex]) +
          '</div>' +
          '</div>'
        );
      },
    },
    // tooltip: {
    //   y: {
    //     formatter: function (val: any) {
    //       return '';
    //     },
    //     title: {
    //       formatter: function (seriesName: any) {
    //         return seriesName;
    //       },
    //     },
    //   },
    // },
  };

  return (
    <div className="">
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
}

export default StackedColumnGraph;
